// extracted by mini-css-extract-plugin
export default {"page":"n7-z","cartModal":"o7-z","checkout":"p7-z","placeholder":"q7-z","account":"r7-z"};